import React from 'react';
import PropTypes from 'prop-types';
import {theme} from 'antd';

const CloseIconDialog = ({callback, image}) => {
  const {token}: any = theme.useToken();

  return (
    <button
      type="button"
      aria-label="Close"
      onClick={() => callback()}
      style={{
        position: 'absolute',
        right: 12,
        top: 12,
        zIndex: 1,
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadius,
        background: token.colorBgContainer,
        padding: 0,
      }}>
      <img src={image} alt="close" style={{width: 14, height: 14}} />
    </button>
  );
};

CloseIconDialog.propTypes = {
  callback: PropTypes.func,
  image: PropTypes.string,
};

export default CloseIconDialog;
